// @ts-nocheck

export const localeCodes =  [
  "ch-de",
  "ch-fr"
]
export const localeLoaders = {
  "ch-de": [
    {
      key: "locale_ch_45de_46json_85edd077",
      load: () => import("#nuxt-i18n/85edd077" /* webpackChunkName: "locale_ch_45de_46json_85edd077" */),
      cache: true
    }
  ],
  "ch-fr": [
    {
      key: "locale_ch_45fr_46json_865daa06",
      load: () => import("#nuxt-i18n/865daa06" /* webpackChunkName: "locale_ch_45fr_46json_865daa06" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d7517427" /* webpackChunkName: "config_i18n_46config_46js_d7517427" */)
]
export const normalizedLocales = [
  {
    code: "ch-de",
    altCode: "ch",
    language: "de-CH",
    shopifyApiDomain: "oneworld-stg-de-ch.myshopify.com",
    shopifyName: "oneworld-stg-de-ch.myshopify.com",
    shopifyApiAccessToken: "0367b15127ca5a76334775d0d443522e",
    newsletterListId: "bc3f4008c6",
    yotpoReviewsLoaderKey: "kaVTQ5y4V1uwQIb0J7GUbNX9Nr3xfugdiCJxd9oM",
    yotpoReviewsWidgetId: "1330704",
    yotpoStarRatingWidgetId: "1330706",
    currency: "CHF"
  },
  {
    code: "ch-fr",
    altCode: "chFr",
    language: "fr-CH",
    shopifyApiDomain: "oneworld-stg-de-ch.myshopify.com",
    shopifyName: "oneworld-stg-de-ch.myshopify.com",
    shopifyApiAccessToken: "0367b15127ca5a76334775d0d443522e",
    newsletterListId: "bc3f4008c6",
    yotpoReviewsLoaderKey: "kaVTQ5y4V1uwQIb0J7GUbNX9Nr3xfugdiCJxd9oM",
    yotpoReviewsWidgetId: "1330704",
    yotpoStarRatingWidgetId: "1330706",
    currency: "CHF"
  }
]

